import { CheckIcon } from "../icons/CheckIcon";
import CircleInvalidIcon from "../icons/CircleInvalidIcon";

function CircleCheckBox({
    color,
    isChecked = false,
    height = 10,
    width = 12,
    checkHeight = 10,
    checkWidth = 12,
    checkedBackgroundColor = '#FE543D',
    checkIconColor = '#FFFFFF',
    whiteChecked = false,
    strokeWidth,
    isCustomNotCheckedIcon = false
}) {


  if (isCustomNotCheckedIcon && isChecked === false) {
    return (
      <CircleInvalidIcon height={height} width={width} className="rounded-checkbox rounded-checkbox--unchecked border-0" />
    )
  }

  return(
    <div 
        className={`
            d-flex align-items-center justify-content-center
            rounded-checkbox
            rounded-checkbox--${isChecked ? 'checked' : 'unchecked'}
            ${whiteChecked && isChecked ? 'rounded-checkbox--checked-white' : ''}
            me-1
        `}
        style={{
            ...(isChecked ? { backgroundColor: checkedBackgroundColor, borderColor: checkedBackgroundColor } : {}),
            height: height,
            width: width
        }}
    >
        {isChecked && (
            <CheckIcon 
              color={checkIconColor} 
              height={checkHeight} 
              width={checkWidth} 
              strokeWidth={strokeWidth}
            />
        )}
    </div>
  );
}

export { CircleCheckBox };